import React from "react";
import * as styles from "./punchCard.styles";
import styled, { css } from "react-emotion";
import PropTypes from "prop-types";

const StyledPunchCard = styled("div")`
  /* display: inline-table; */
  color: black;
  width: 100%;
  background: #6edb97; /* TODO: update this dynamically later on */
  box-sizing: content-box;
  border-radius: 5px;
  text-align: center;
  margin: ${(props) => (props.margin ? props.margin : "5 0 10 0")};
  /* background: ${(props) =>
    props.background ? props.background : "#89d2d3"}; */
  background: ${(props) => (props.background ? props.background : "white")};
  border: ${(props) => "1px solid " + props.color};
  /* background: ${(props) => props.background}; */
  padding: 10px 0px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background: #e7e7e7;
    transform: scale(1.02);
  }
`;

const RedeemButton = styled("p")`
  background: white;
  border-radius: 25px;
  border: ${(props) => "1px solid " + props.color};
  color: ${(props) => props.color};
  font-size: 12px;
  padding: 10px;
  width: 200px;
  margin: 20px auto !important;
`;

const smallText = css`
  font-size: 9px;
  height: auto;
  color: white;
`;

const finePrintStyle = css`
  font-size: 9px;
  word-wrap: break-word;
  color: black;
  text-decoration: underline;
  text-align: right;
  margin-right: 10px;
`;

const descriptionStyle = css`
  color: black;
  /* word-wrap: break-word; */
`;

const Punchcard = ({
  id,
  title,
  numberOfUses,
  retired,
  finePrint,
  onClick,
  margin,
  description,
  border,
  barColor,
}) => {
  const generateStamps = () => {
    if (numberOfUses < 1) return null;
    const imgProps = {
      src: "https://mobile360-assets.s3.us-east-2.amazonaws.com/star.png",
      style: {
        width: "25px",
      },
    };

    const starPerRow = () => {
      if (numberOfUses % 6 === 0 || numberOfUses % 6 === 5) {
        return (10 / 6) * 10;
      } else {
        return (10 / 5) * 10;
      }
    };

    return (
      <styles.StarGroup>
        {[...Array(numberOfUses)].map((el) => {
          return (
            <div
              key={el}
              style={{
                width: `${starPerRow()}%`,
              }}
            >
              <img {...imgProps} />
            </div>
          );
        })}
      </styles.StarGroup>
    );
  };
  // console.log("got id from punchcard: " + id);
  return (
    <StyledPunchCard
      // id="punchCardRide"
      border={border}
      margin={margin}
      background={retired ? "grey" : null}
      onClick={() => onClick(id)}
      color={barColor}
    >
      <h2 style={{ color: "black" }}>{title}</h2>

      {description ? (
        <p className={descriptionStyle}>{description}</p>
      ) : (
        <p className={descriptionStyle}></p>
      )}
      {generateStamps()}
      <RedeemButton color={barColor}>Get A Stamp!</RedeemButton>

      {finePrint ? (
        <p className={finePrintStyle}>Fine Print</p>
      ) : (
        <p className={finePrintStyle}></p>
      )}
    </StyledPunchCard>
  );
};

Punchcard.propTypes = {
  cards: PropTypes.object,
  onClick: PropTypes.func,
};

export default Punchcard;
